/**
 * State for navigation transitions that need to remain visible until app
 * content has actually rendered, not merely until Angular Router accepts a URL.
 */
export interface State {
  readonly transition?: State.Transition
  readonly lastTransitionId: number
}

export namespace State {
  export const INITIAL: State = {
    lastTransitionId: 0,
  }

  /**
   * A single in-flight visual transition.
   */
  export interface Transition {
    readonly id: number
  }

  /**
   * Starts a new transition and gives it an id so delayed completions from
   * older navigations cannot finish a newer one.
   */
  export function startTransition(state: State): State {
    const id = state.lastTransitionId + 1

    return {
      ...state,
      lastTransitionId: id,
      transition: { id },
    }
  }

  /**
   * Finishes the current transition when the caller is finishing the same
   * transition that was active when its delayed work began.
   */
  export function finishTransition(state: State, id: number): State {
    if (state.transition?.id !== id) {
      return state
    }

    return {
      ...state,
      transition: undefined,
    }
  }
}
